import { MonitorQuestion } from '../../../models/monitor/MonitorQuestion';
import { client } from '../../../services/apiClient';
import { DateRange } from '../../../models/monitor/DateRange';

const PROMPT_ENDPOINT = '/monitor/prompt';

export const addPrompts = async (
  projectId: number,
  monitorQuestions: MonitorQuestion[]
): Promise<boolean> => {
  const { data } = await client(true, true).put<boolean>(
    `${PROMPT_ENDPOINT}/add/${projectId}`,
    monitorQuestions
  );
  return data;
};

export const getDateRange = async (projectId: number): Promise<DateRange> => {
  const { data } = await client(true, true).get<DateRange>(`${PROMPT_ENDPOINT}/date-range/${projectId}`);
  return data;
};
